import { render } from "./CompanySectorCreate.vue?vue&type=template&id=3d25f572"
import script from "./CompanySectorCreate.vue?vue&type=script&lang=js"
export * from "./CompanySectorCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__